import { getClient } from "src/api/api.ts";
import { HttpError } from "src/api/httpError.ts";
import { TrackingEvent } from "src/model/trackingEvent.ts";

export const fetchTrackingEvents = async (
  subscriptionId: string,
  containerNumber: string
): Promise<TrackingEvent[]> => {
  const {
    data,
    error,
    response: { status },
  } = await getClient().GET(
    "/API/iSEA5/V2.1/Subscriptions/{subscriptionId}/Containers/{containerNumber}/TrackingEvents",
    {
      params: {
        path: {
          subscriptionId: subscriptionId,
          containerNumber: containerNumber,
        },
      },
    }
  );

  if (error !== undefined) {
    if (error.loggingMessage) {
      throw new HttpError(status, error.loggingMessage);
    }
    throw new HttpError(status, error.message);
  }

  if (data !== undefined) {
    return data;
  }

  throw new Error("Failed to fetch tracking events");
};
